import {
  //
  ADD_BUDGET,
  ADD_BUDGET_FAILURE,
  ADD_BUDGET_SUCCESS,
  //
  DELETE_BUDGET,
  DELETE_BUDGET_FAILURE,
  DELETE_BUDGET_SUCCESS,
  //
  EDIT_BUDGET,
  EDIT_BUDGET_FAILURE,
  EDIT_BUDGET_SUCCESS,
  //
  FETCH_BUDGET,
  FETCH_BUDGET_FAILURE,
  FETCH_BUDGET_SUCCESS,
  //
  GET_VIEW_DATA,
  GET_VIEW_DATA_FAILURE,
  GET_VIEW_DATA_SUCCESS,
  //
  SET_WEEK,
  TOGGLE_BUDGET_CONFIRM,
  //
  COPY_BUDGET,
  COPY_BUDGET_SUCCESS,
  COPY_BUDGET_FAILURE,
  //
  BULK_UPDATE,
  BULK_UPDATE_SUCCESS,
  BULK_UPDATE_FAILURE,
  //
  GET_BUDGET_HISTORY,
  GET_BUDGET_HISTORY_SUCCESS,
  GET_BUDGET_HISTORY_FAILURE,
  //
  TOGGLE_BUDGET_MODAL,
  TOGGLE_ADD_MODAL,
  TOGGLE_COPY_MODE,
  SET_COPY_DATA,
} from "./constants";

// List
export const fetchBudget = (payload, onBudgetSuccess) => ({
  type: FETCH_BUDGET,
  payload,
  onBudgetSuccess,
});
export const fetchBudgetSuccess = (payload) => ({
  type: FETCH_BUDGET_SUCCESS,
  payload,
});
export const fetchBudgetFailure = (payload) => ({
  type: FETCH_BUDGET_FAILURE,
  payload,
});
// View
export const getViewData = (payload) => ({
  type: GET_VIEW_DATA,
  payload,
});
export const getViewDataSuccess = (payload) => ({
  type: GET_VIEW_DATA_SUCCESS,
  payload,
});
export const getViewDataFailure = (payload) => ({
  type: GET_VIEW_DATA_FAILURE,
  payload,
});
// ADD
export const addBudget = (payload, onBudgetAdd) => ({
  type: ADD_BUDGET,
  payload,
  onBudgetAdd,
});
export const addBudgetSuccess = (payload) => ({
  type: ADD_BUDGET_SUCCESS,
  payload,
});
export const addBudgetFailure = (payload) => ({
  type: ADD_BUDGET_FAILURE,
  payload,
});
// EDIT
export const editBudget = (payload, onBudgetEdit) => ({
  type: EDIT_BUDGET,
  payload,
  onBudgetEdit,
});
export const editBudgetSuccess = (payload) => ({
  type: EDIT_BUDGET_SUCCESS,
  payload,
});
export const editBudgetFailure = (payload) => ({
  type: EDIT_BUDGET_FAILURE,
  payload,
});
// DELETE
export const deleteBudget = (payload, onDelete) => ({
  type: DELETE_BUDGET,
  payload,
  onDelete,
});
export const deleteBudgetSuccess = (payload) => ({
  type: DELETE_BUDGET_SUCCESS,
  payload,
});
export const deleteBudgetFailure = (payload) => ({
  type: DELETE_BUDGET_FAILURE,
  payload,
});

export const setBudgetWeek = (payload) => ({
  type: SET_WEEK,
  payload,
});

export const toggleBudgetConfirm = (payload) => ({
  type: TOGGLE_BUDGET_CONFIRM,
  payload,
});

export const copyBudget = (payload, onCopySuccess) => ({
  type: COPY_BUDGET,
  payload,
  onCopySuccess,
});
export const copyBudgetSuccess = (payload) => ({
  type: COPY_BUDGET_SUCCESS,
  payload,
});
export const copyBudgetFailure = (payload) => ({
  type: COPY_BUDGET_FAILURE,
  payload,
});

export const bulkUpdate = (payload, onUpdate) => ({
  type: BULK_UPDATE,
  payload,
  onUpdate,
});
export const bulkUpdateSuccess = (payload) => ({
  type: BULK_UPDATE_SUCCESS,
  payload,
});
export const bulkUpdateFailure = (payload) => ({
  type: BULK_UPDATE_FAILURE,
  payload,
});

export const getBudgetHistory = (payload) => ({
  type: GET_BUDGET_HISTORY,
  payload,
});
export const getBudgetHistorySuccess = (payload) => ({
  type: GET_BUDGET_HISTORY_SUCCESS,
  payload,
});
export const getBudgetHistoryFailure = (payload) => ({
  type: GET_BUDGET_HISTORY_FAILURE,
  payload,
});

//
export const toggleBudgetModel = (payload) => ({
  type: TOGGLE_BUDGET_MODAL,
  payload,
});
export const toggleAddModal = (payload) => ({
  type: TOGGLE_ADD_MODAL,
  payload,
});
export const toggleCopyMode = (payload) => ({
  type: TOGGLE_COPY_MODE,
  payload,
});
export const setCopyData = (payload) => ({
  type: SET_COPY_DATA,
  payload,
});
